export const CONFIG = {
  publicationCount: 51,
  hIndex: 11,
  i10Index: 13,
  inrUsdRate: 86,
  lastUpdated: "June 2026",
  scholarUrl: "https://scholar.google.com/citations?user=8cdLLjYAAAAJ",
  linkedinUrl: "https://www.linkedin.com/in/dr-keyur-sorathia/",
  youtubeUrl: "https://www.youtube.com/@embeddedinteractionlabeila957",
  emailOfficial: "keyur@iitg.ac.in",
  emailPersonal: "keyurbsorathia@gmail.com",
  phone: "+91 361 258 2485",
  address: "Department of Design, Indian Institute of Technology Guwahati, Assam 781039, India",
  cvOnePage: "/keyur-sorathia-cv-one-page.pdf",
  cvFull: "/keyur-sorathia-cv-full.pdf",
};

export const RESEARCH_QUESTIONS = [
  {
    number: "01",
    title: "Cultural transfer in immersive science learning",
    question:
      "Does an immersive system authored for one curriculum, one context and one cultural setting still produce a learning gain when it crosses into another?",
    shortForm: "Cultural transfer",
    shown:
      "Gyan Dhara showed a curriculum-aligned system, authored against a state syllabus and delivered multilingually, reaching sixty schools. Pragati delivered mobile virtual-reality training to more than 600 community health workers on their own phones.",
    open:
      "Nothing in the literature establishes what transfers across a curriculum boundary. A multi-site, multi-lingual, multi-curriculum study is the obvious next design, and it needs more than one education system to run in.",
    recruiting:
      "Does an immersive system authored for one curriculum, one context and one cultural setting still produce a learning gain when it crosses into another? It needs a candidate willing to run a genuinely multi-site study.",
  },
  {
    number: "02",
    title: "For how long it reaches: longitudinal adoption of immersive learning",
    question:
      "What happens at six weeks, at six months, and in the third year, once novelty is gone?",
    shortForm: "Longitudinal adoption",
    shown:
      "The Sound module in Gyan Dhara produced a learning gain that was still present at six-week delayed testing with no decay, which is uncommon in the literature.",
    open:
      "Longitudinal adoption is the least-studied and most decision-relevant question in the field. Almost every published gain is measured within minutes of the headset coming off.",
    recruiting:
      "Almost every published learning gain is measured within minutes of the headset coming off. What happens at six weeks, at six months, and in the third year, once novelty is gone and an institution has to keep paying to maintain the system? It needs a candidate willing to track one deployment well past its launch.",
  },
  {
    number: "03",
    title: "Room-scale and hybrid immersion as learning infrastructure",
    question:
      "Headsets are one configuration. What is the right mix of room-scale projection, haptics, handheld and headset for immersive learning?",
    shortForm: "Room-scale and hybrid immersion",
    shown:
      "Both deployments so far ran one learner to one device. Gyan Dhara puts an individual student in a standalone headset, with several students working through a module at the same time in an ordinary school hall that has no fixed installation. Pragati put an individual health worker into a low-cost viewer on the phone she already owned. Two very different hardware tiers, the same one-to-one configuration.",
    open:
      "Room-scale projection, haptics, handheld and hybrid combinations are all untested in my own work. What is the right configuration for immersive learning at classroom scale?",
    recruiting:
      "Headsets are one configuration. What is the right mix of room-scale projection, haptics, handheld and headset for immersive learning?",
  },
];
